export enum ActionTypes {
  AUTHNZ_CONFIRM_REGISTRATION = "AUTHNZ_CONFIRM_REGISTRATION",
  AUTHNZ_FORGOT_PASSWORD = "AUTHNZ_FORGOT_PASSWORD",
  AUTHNZ_FORGOT_PASSWORD_RESET = "AUTHNZ_FORGOT_PASSWORD_RESET",
  AUTHNZ_RESEND_CODE = "AUTHNZ_RESEND_CODE",
  AUTHNZ_SET_NEW_PASSWORD_REQUIRED = "AUTHNZ_SET_NEW_PASSWORD_REQUIRED",
  AUTHNZ_UPDATE_PASSWORD = "AUTHNZ_UPDATE_PASSWORD",
  AUTHNZ_USER_LOG_OUT = "AUTHNZ_USER_LOG_OUT",
  AUTHNZ_USER_SIGN_IN = "AUTHNZ_USER_SIGN_IN",
  AUTHNZ_USER_SIGN_UP = "AUTHNZ_USER_SIGN_UP",
}
